import { alpha } from '@material-ui/core/styles/colorManipulator';
import cyan from '@material-ui/core/colors/cyan';
import indigo from '@material-ui/core/colors/indigo';
import red from '@material-ui/core/colors/red';
import bg from 'dan-images/petal_grey_bg.svg';
import bgLight from 'dan-images/petal_bg.svg';
import { gradientBgLight } from 'containers/Templates/appStyles-jss';
const rootWraper = {
  display: 'flex',
  width: '100%',
  zIndex: 1,
  position: 'relative',
  //backgroundImage: `url(${background})`,
  //backgroundSize: 'cover',
};

const wrapper = (theme, opacity) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  backgroundColor: alpha(theme.palette.background.paper, opacity),
  backgroundRepeat: 'no-repeat',
  color: theme.palette.text.primary,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed'
});

const styles = theme => ({
  root: {
    ...rootWraper,
    "&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)": {
      backgroundColor: "rgb(167, 202, 237)"
    },
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgb(167, 202, 237)"
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "rgb(51, 72, 153)"
    },
    "& .MuiLinearProgress-dashedColorPrimary": {
      backgroundImage:
        "radial-gradient(rgb(167, 202, 237) 0%, rgb(167, 202, 237) 16%, transparent 42%)"
    }
  },
  rootJaviKurye: {
    ...rootWraper,
    "&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)": {
      backgroundColor: "#ff7675"
    },
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "#ff7675"
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "rgb(190, 29, 45)"
    },
    "& .MuiLinearProgress-dashedColorPrimary": {
      backgroundImage:
        "radial-gradient(#ff7675 0%, #ff7675 16%, transparent 42%)"
    }
  },
  MuiFormControlLogin:{
    '& input': {
      border: '1px solid rgba(0, 0, 0, 0.23) !important',
      color:'rgba(0, 0, 0, 0.87)',
      borderRadius:8,
      fontWeight:600
    },
    '&:after': {
      left: 0,
      right: 0,
      bottom: -1,
      height: 'calc(100% + 1px)',
      position: 'absolute',
      transform: 'scaleX(0)',
      boxShadow: '0 0 1px #BE1D2D',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      borderBottom: '2px solid #BE1D2D',
      borderRadius: 8,
      pointerEvents: 'none'
    }
  },
  MuiFormControlLoginUser:{
    '& input': {
      border: '1px solid rgba(0, 0, 0, 0.23) !important',
      color:'rgba(0, 0, 0, 0.87)',
      borderRadius:8,
      fontWeight:600
    },
    '&:after': {
      left: 0,
      right: 0,
      bottom: -1,
      height: 'calc(100% + 1px)',
      position: 'absolute',
      transform: 'scaleX(0)',
      boxShadow: '0 0 1px rgb(51, 72, 153)',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      borderBottom: '2px solid rgb(51, 72, 153)',
      borderRadius: 8,
      pointerEvents: 'none'
    }
  },
  MuiFormControlLoginCh:{
    color:'rgba(0, 0, 0, 0.6)',
  },
  errorspan: {
    textAlign: '-webkit-left',
    marginLeft: '10px',
    marginTop: '5px',
    color: '#e74c3c',
    fontWeight: '600',
    fontSize: '13px'
  },
  rootFull: {
    ...rootWraper,
    height: '100%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden'
    },
  },
  containerSide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden'
    },
  },
  paperWrap: {
    ...wrapper(theme, 1),
  },
  sideWrap: {
    ...wrapper(theme, 1),
    height: '100%',
    borderRadius: 0,
    [theme.breakpoints.up('md')]: {
      width: 500,
    },
    '& $topBar': {
      width:'100%',
      padding: theme.spacing(1),
    },
  },
  fullWrap: {
    ...wrapper(theme, 0.9),
    height: '100%',
    borderRadius: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& $topBar': {
      width: '100%'
    }
  },
  petal: {
    backgroundImage: theme.palette.type === 'dark' ? `url(${bgLight})` : `url(${bg})`,
  },
  icon: {},
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    '& $icon': {
      marginRight: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginBottom: theme.spacing(3),
      '& a': {
        display: 'none'
      }
    }
  },
  outer: {},
  brand: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 10px',
    position: 'relative',
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&$outer': {
      color: theme.palette.common.white,
    },
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(2)
    },
    '& img': {
      height: 35,
      marginRight: 10,
    },
  },
  formWrap: {
    [theme.breakpoints.up('sm')]: {
      padding: '0 100px'
    },
    [theme.breakpoints.up('md')]: {
      padding: '0 150px'
    },
  },
  pageFormWrap: {
    width: '100%',
    margin: `${theme.spacing(2)}px auto`,
    [theme.breakpoints.up('sm')]: {
      width: 480,
    },
  },
  pageFormSideWrap: {
    margin: '0 auto',
    [theme.breakpoints.only('sm')]: {
      width: 480,
    },
  },
  formControl: {
    width: '100%'
  },
  socmedLogin: {
    [theme.breakpoints.up('sm')]: {
      padding: '24px 100px 1px',
    },
    '& button': {
      padding: '4px 24px'
    }
  },
  socmedSideLogin: {
    padding: '24px 24px 1px',
    margin: '0 auto',
    '& button': {
      padding: '4px 16px',
      margin: `0 ${theme.spacing(1)}px`
    },
    [theme.breakpoints.only('sm')]: {
      width: 480,
    },
  },
  userFormWrap: {
    width: '94%',
    [theme.breakpoints.up('md')]: {
      width: 720
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3)
    },
  },
  sideFormWrap: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    position:'relative'
  },
  fullFormWrap: {
    height: '100%',
    width: '100%'
  },
  title: {
    color: '#334899',
    fontWeight:600
  },
  subtitle: {
    fontSize: 14
  },
  titleGradient: {
    background: gradientBgLight(theme),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(3),
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.55em'
    }
  },
  codeStylePIN: {
    width: '100% !important',
    marginTop: 10,
    marginBottom: 10,
    '& input': {
      color: 'white !important',
      fontFamily: 'Quicksand,sans-serif !important',
      borderRadius: '50px !important',
      width: '60px !important',
      height: '60px !important',
      marginRight: '5px !important',
      border: '2px solid white !important'
    },
    '& input:focus': {
      outline: 'none',
      border: '2px solid rgb(39, 99, 147) !important',
      caretColor: 'rgb(39, 99, 147)'
    },
  },
  inputPinCode: {
    fontSize:24,
    color:'white'
  },
  codeStyle: {
    width: '100% !important',
    '& input': {
      color: 'white !important',
      fontFamily: 'Quicksand,sans-serif !important',
      borderRadius: '50px !important',
      width: '60px !important',
      height: '60px !important',
      marginRight: '5px !important',
      border: '2px solid white !important'
    },
    '& input:focus': {
      outline: 'none',
      border: '2px solid rgb(39, 99, 147) !important',
      caretColor: 'rgb(39, 99, 147)'
    },
  },
  opening: {
    color: theme.palette.common.black,
    width: '100%',
    textAlign: 'center',
    '& h1': {
      display: 'block',
      [theme.breakpoints.down('md')]: {
        fontSize: 32,
        lineHeight: '48px'
      }
    },
    '& p': {
      color: theme.palette.common.black,
      fontSize: 18,
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
      }
    }
  },
  label: {},
  btnArea: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: `${theme.spacing(2)}px 0`,
    fontSize: 12,
    '& $label': {
      fontSize: 12,
      '& span': {
        fontSize: 12
      }
    },
    '& button': {
      margin: `0 ${theme.spacing(1)}px`
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& button': {
        width: '100%',
        margin: 5
      }
    },
  },
  noMargin: {
    margin: 0
  },
  redBtn: {
    color: red[500],
    borderColor: red[500],
    '&:hover': {
      borderColor: red[700],
    },
  },
  blueBtn: {
    color: indigo[300],
    borderColor: indigo[300],
    '&:hover': {
      borderColor: indigo[500],
    },
  },
  cyanBtn: {
    color: cyan[500],
    borderColor: cyan[500],
    '&:hover': {
      borderColor: cyan[700],
    },
  },
  buttonLink: {
    background: 'none',
    padding: 0,
    textTransform: 'none',
    transition: 'color ease 0.3s',
    fontWeight: 600,
    fontSize: '0.875rem',
    '&:hover': {
      background: 'none',
      color: theme.palette.primary.main
    }
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
  footer: {
    textAlign: 'center',
    padding: 5,
    background: theme.palette.grey[100],
    fontSize: 14,
    position: 'relative'
  },
  welcomeWrap: {
    position: 'relative'
  },
  tab: {
    margin: `${theme.spacing(3)}px 0 ${theme.spacing(1)}px`,
  },
  link: {
    fontSize: '0.875rem',
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  socmedFull: {
    textAlign: 'center',
    width: '100%',
    margin: `${theme.spacing(3)}px ${theme.spacing(1)}px`,
    '& button': {
      width: '100%',
      display: 'block',
      margin: `0 auto ${theme.spacing(2)}px`
    },
    [theme.breakpoints.up('sm')]: {
      '& button': {
        width: 400,
      }
    }
  },
  lockWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  lockForm: {
    display: 'flex',
    alignItems: 'baseline',
    '& div': {
      width: '100% !important',
    }
  },
  notifyForm: {
    alignItems: 'baseline',
    [theme.breakpoints.down('xs')]: {
      '& button': {
        marginTop: theme.spacing(3),
        width: '100%'
      },
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      '& button': {
        width: 'auto'
      }
    }
  },
  lockField: {
    marginRight: theme.spacing(1),
    '& label': {
      color: `${theme.palette.common.white} !important`,
    },
    '& label + div': {
      background: alpha(theme.palette.primary.light, 0.3),
      border: 'none',
      '& svg': {
        fill: alpha(theme.palette.common.white, 0.7)
      }
    }
  },
  avatar: {
    width: 150,
    height: 150,
    [theme.breakpoints.up('lg')]: {
      marginRight: theme.spacing(3),
    },
    boxShadow: theme.glow.medium
  },
  userName: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(3),
      textAlign: 'center'
    }
  },
  hint: {
    padding: theme.spacing(1)
  },
  brandCenter: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
  },
  centerAdornment: {
    justifyContent: 'center',
    '& > div': {
      width: '100%'
    },
    '& aside': {
      top: -10,
      [theme.breakpoints.up('sm')]: {
        left: 10,
      },
      position: 'relative'
    }
  },
  centerV: {
    justifyContent: 'center'
  },
  optArea: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `0 ${theme.spacing(0.5)}px`,
    '& span': {
      fontSize:13,
      fontWeight:600,
      color:'#808080',
    }
  },
});

export default styles;
